import cookie from 'js-cookie';
import COOKIE_KEYS from '../../configs/app.cookie';
import { API, post } from '../../net/http';

export default {
  namespaced: true,
  actions: {
    register(context, body) {
      return post(API.signup, body, { 'content-type': 'application/x-www-form-urlencoded' }).then(res => {
        return res;
      });
    },
    logout({ commit }) {
      cookie.remove(COOKIE_KEYS.userName);
      return post(API.logout).then(res => {
        if (res.status) {
          commit('app/logout');
        }
        return res;
      });
    },
  },
};
